import axios from 'axios';
import { ConfigService } from 'services/configService';

const UtilsService = {
  async getInfo() {
    const response = await axios.get(`${ConfigService._apiUrlUtlsInfo}`);
    return response.data;
  }
};

export const storeFormPathInSession = (form, ext) => {
  if (ext) {
    sessionStorage['form_path'] = `/${form}/${ext}`;
  } else {
    sessionStorage['form_path'] = `/${form}`;
  }
};

export default UtilsService;
